import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLocalStorageItem } from '../utils/helper';
import { Helmet } from 'react-helmet';
import Topbar from './PulseSurvey/Topbar';
import KidsDashboardSection1 from './KidsDashboardContent/Section1';
import KidsDashboardSection2 from './KidsDashboardContent/Section2';
import KidsDashboardSection3 from './KidsDashboardContent/Section3';
import KidsDashboardSection4 from './KidsDashboardContent/Section4';
import KidsDashboardSection5 from './KidsDashboardContent/Section5';
import KidsDashboardSection6 from './KidsDashboardContent/Section6';
import KidsDashboardSection7 from './KidsDashboardContent/Section7';
import { Api } from '../api';

function KidsDashboard() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  const [moodStats, setMoodStats] = useState([]);
  const [kidsDetails, setKidsDetails] = useState([]);
  const [accountDetails, setAccountDetails] = useState([]);
  const [allStats, setAllStats] = useState([]);
  const [focusStats, setFocusStats] = useState([]);
  const [gamesStats, setGamesStats] = useState([]);
  const [audioStats, setAudioStats] = useState([]);
  const [storyStats, setStoryStats] = useState([]);
  const [exercises, setExercises] = useState([]);

  useEffect(() => {
    if (userData.userType || userData.userType === 0) {
      navigate(userData?.slug ? `/${userData?.slug}/dashboard` : '/kids-dashboard');
    }
    setLoader(true);
    getKidsDetails();

    getAudiosStats();

    setLoader(false);
  }, []);

  // SECTION 1
  const getKidsDetails = () => {
    Api.getKidsDetailsStats().then((res) => {
      setKidsDetails(res?.data.data);
    });
  };

  //SECTION 6
  const getAudiosStats = () => {
    Api.getAudioStats().then((res) => {
      setAudioStats(res?.data?.data);
    });
  };

  return (
    <div className="relative lg:px-5 lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kids Dashboard | Shoorah Admin</title>
      </Helmet>
      <Topbar title={'Hi ' + userData?.name} />

      <KidsDashboardSection1 kidsDetails={kidsDetails} storyDetails={audioStats} />
      {/* <KidsDashboardSection2 allStats={allStats} />
      <KidsDashboardSection3 focusStats={focusStats} /> */}
      {/* <KidsDashboardSection4 moodStats={moodStats} />
      <KidsDashboardSection5 gameStats={gamesStats} /> */}
      <KidsDashboardSection6 audioStats={audioStats} />
      {/* <KidsDashboardSection7 exercises={exercises} audioStats={audioStats} /> */}
    </div>
  );
}

export default KidsDashboard;
